import { createContext } from 'react';

const specCodeContext = createContext();

export default specCodeContext;
